import type { MinimalWhoAmITherapist } from '@tebuto/api/clients/models/MinimalWhoAmITherapist'

// Seminar participants have a separate, limited portal permission.
export function activeClientTherapists(therapists: MinimalWhoAmITherapist[]): MinimalWhoAmITherapist[] {
    return therapists.filter((therapist) => therapist.isActive || therapist.canAccessSeminars)
}
